export default "__VITE_ASSET__CUK7FYRJ__"